<template>
  <Modal :value="visible"
         :title="$t('pages_products_components_new_sku_modal_753')"
         :footer-hide="true"
         :width="800"
         @on-cancel="toggle">
    <Alert type="warning"
           v-if="form.selectedSpecs.length">{{$t('pages_products_components_new_sku_modal_754')}}<span slot="desc">规格一旦选择不可更改，所有 sku 都需要包含 {{ form.selectedSpecs.join('、') }}</span>
    </Alert>
    <i-form :label-colon="true"
            :rules="formRules"
            :label-width="100"
            label-position="left"
            :model="form"
            ref="form">
      <FormItem prop="selectedSpecs"
                :label="$t('pages_products_components_new_sku_modal_756')"
                :rules="rule1">
        <el-checkbox-group v-model="form.selectedSpecs">
          <el-checkbox :disabled="fixedSpecs.length > 0"
                       v-for="item in specs"
                       :key="item.id"
                       :label="item.name">
          </el-checkbox>
        </el-checkbox-group>
      </FormItem>
      <FormItem v-for="spec in selectedSpecList"
                :key="spec.id"
                :label="spec.name"
                :prop="`selectedValues.${spec.id}`"
                :rules="[{required: true, message: `${spec.name}${$t('pages_products_components_new_sku_modal_757')}`}]">
        <RadioGroup v-model="form.selectedValues[spec.id]">
          <Radio v-for="item in spec.mall_property_values"
                 :key="item.id"
                 :label="item.id">
            <span>{{ item.name }}</span>
          </Radio>
        </RadioGroup>
        <!-- <el-select v-model="form.selectedValues[spec.id]"
                   filterable>
          <el-option v-for="item in spec.mall_property_values"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select> -->
      </FormItem>
      <FormItem :label-width="0"
                style="text-align: center">
        <i-button type="primary"
                  size="large"
                  style="width: 150px"
                  @click="onSubmit">{{$t('pages_combo_index_284')}}</i-button>
      </FormItem>
    </i-form>
  </Modal>
</template>

<script>
import i18n from '../../../locales/index'

import { mapActions, mapState } from 'vuex';
import md5 from 'blueimp-md5';

function getDefaults () {
  return {
    selectedSpecs: [],
    selectedSpecIds: [],
    selectedValues: {},
  }
}

export default {
  name: 'NewSkuModal',
  props: ['visible', 'fixedSpecs', 'currentSkuProp'],
  data () {
    return {
      formRules: {},
      form: getDefaults(),
      selectedValues: {},
      rule1: [{required: true, message: i18n.t('pages_booking_store_products_index_219')}]
    }
  },
  computed: {
    ...mapState("mall_property_name", {
      specs: "mall_property_names"
    }),
    specValueMap () {
      const map = this.specs.reduce((map, item) => {
        map[this.nameMd5Map.get(item.name)] = item.mall_property_values;
        return map;
      }, {});
      return map;
    },
    // Map { [name: string]: md5string }
    nameMd5Map () {
      const map = new Map();
      this.specs.forEach(spec => {
        map.set(spec.name, md5(spec.name));
      });
      return map;
    },
    // 选中的规格列表 [{id: number, name: string}]
    selectedSpecList () {
      const result = this.specs.filter(item => this.form.selectedSpecIds.includes(item.id));
      return result;
    },
    // {nameid_valueid: [{mall_property_name_id, mall_property_name_name, mall_property_value_id, mall_property_value_name}]}
    nameValueMap () {
      const result = {};
      this.specs.forEach(spec => {
        spec.mall_property_values.forEach(value => {
          result[`${spec.id}_${value.id}`] = {
            mall_property_name_id: spec.id,
            mall_property_name_name: spec.name,
            mall_property_value_id: value.id,
            mall_property_value_name: value.name,
          }
        });
      });
      return result;
    }
  },
  watch: {
    fixedSpecs: {
      immediate: true,
      handler (ids) {
        this.form.selectedSpecIds = ids;
        this.form.selectedSpecs = this.specs.filter(i => ids.includes(i.id)).map(i => i.name);
      }
    },
    'form.selectedSpecs': {
      immediate: true,
      handler (names) {
        const ids = this.specs.filter(i => names.includes(i.name)).map(i => i.id);
        this.form.selectedSpecIds = ids;
        ids && ids.forEach((id) => {
          if (!Object.prototype.hasOwnProperty.call(this.form.selectedValues, `${id}`)) {
            this.$set(this.form.selectedValues, `${id}`, null);
          }
        });
      }
    },
    currentSkuProp: {
      immediate: true,
      deep: true,
      handler (props) {
        if (!props.length) {
          this.form.selectedValues = {}
          this.selectedValues = {}
          return
        }
        props.map(prop => {
          const { mall_property_name_id, mall_property_value_id } = prop
          this.form.selectedValues[mall_property_name_id] = mall_property_value_id
        })
        this.selectedValues = { ...this.form.selectedValues }
      }
    }
  },
  methods: {
    ...mapActions("mall_property_name", {
      fetchSpecs: "index"
    }),
    rules (id) {
      return [{
        validator: (rule, value, callback) => {
          if (!value || !value[id]) {
            callback(new Error())
          }
        }
      }]
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const result = Object.keys(this.form.selectedValues).reduce((rt, specId) => {
            const valueId = this.form.selectedValues[specId];
            const detail = this.nameValueMap[`${specId}_${valueId}`];
            if (detail) {
              rt.push(detail);
            }
            return rt;
          }, []);
          this.$emit('submit', result);
        } else {
          this.$Message.error(i18n.t('pages_products_components_new_sku_modal_758'));
        }
      })
    },
    toggle () {
      this.form.selectedValues = { ...this.selectedValues }
      this.$emit('toggle');
    }
  },
  mounted () {
    this.form = getDefaults()
    this.fetchSpecs({ page: 1, per: 65535 });
  }
}
</script>

<style>
</style>
